import * as Sentry from "@sentry/vue";
import { getUserInfoApi } from "@/network/NetworkUser";
import { defineStore } from "pinia";


export const useUserStore = defineStore("user", () => {
    // 定义用户信息
    const userInfo = ref();


    // 设置用户信息
    const setUserInfo = (data: any) => {
        userInfo.value = data;
        localStorage.setItem("storeId", data?.shop_selected?.store_id);
    };

    const clearUserInfo = () => {
        userInfo.value = undefined;
    };

    watch(userInfo, (uif) => {
        if (uif == null) {
            Sentry.setUser(null);
            return;
        }
        Sentry.setUser({
            id: `${uif?.id}`,
            username: uif?.nickname,
            comments: `${uif?.shop_selected?.store_id}-${uif?.shop_selected?.store}`
        });
    }, { immediate: true });

    // 获取用户信息
    const getUserMe = async () => {
        try {
            const res = await getUserInfoApi();
            setUserInfo(res.data);
            return res.data;
        } catch (error) {
            clearUserInfo();
            return null;
        }
    };



    return {
        userInfo,
        getUserMe,
        clearUserInfo,
        setUserInfo
    };
},

// 持久化
{
    persist: true
});
